import { ApiCodes } from './error-code';

class ApiManager {

  async _prepareParams(params) {
    try {
        return {
          ...params
        };
    } catch (error) {
      return Promise.reject({ code: ApiCodes.GET_USER_INFO_FAIL });
    }
  }

  async callJson (method, headers, url, body) {

    headers = {
      ...headers,
      'Content-Type': 'application/json',
    };

    var rawResponse = await fetch(url, {
      method: method,
      headers: headers,
      body: body
    });
    const content = await rawResponse.json();
    return content
  };

  async call (method, headers, url, body) {
    headers = {
      ...headers,
      'Content-Type': 'application/json',
    };
    return await fetch(url, {
      method: method,
      headers: headers,
      body: body
    });
  };

  async request(apiPath, params = {}, method = 'POST') {

    const headers = {
      'Content-Type': 'application/json',
    };

    var domain = window.runtime_configs.REACT_APP_API_ENDPOINT;
    const url = domain +  apiPath;
    console.log("info", "call api:", url);
    console.log("info", "api headers: ", headers);
    console.log("info", "api params: ", params);

    var body =  method === 'GET' ? undefined : JSON.stringify(params);
    return fetch(url, {
      method: method,
      headers: headers,
      body: body,
    })
      .then(resp => {
        console.log("info", "fetch resp: ", resp);
        return resp.json();
      })
      .then(resp => ({ ...resp }))
      .catch(error => {
        console.log("error", "fetch error: " + error);
          Promise.reject({ ...error, code: parseInt(error.code) })
        }
      );
  }
}
export default ApiManager;
